<script setup lang="ts">
import {useStore} from 'vuex';

const store = useStore();
const divisionName = store.state.subdomain.divisionName;
const questionList = [
  {
    question: "What if I don't have a printer?",
    answer:
      'If you don’t have a printer, please include a note referencing your order ID number, your name and email address, plus the Customer Reference number on your returns label.',
  },
  {
    question: 'How do I return my items?',
    answer:
      'Take your parcel to your nearest post office and make sure you request and keep the proof of postage receipt.',
  },
  {
    question: 'Is it free to return my items?',
    answer:
      'Returns are FREE for U.K. customers. If you are a customer from outside the U.K., you will need to pay to post your items back to us',
  },
  {
    question: 'How long will it take to process my return?',
    answer: `Returns may take 1 to 3 weeks to process, but you’ll receive an email from the returns team as soon as your items have been processed. Thanks again for shopping with ${divisionName}`,
  },
];
</script>

<template>
  <tml-expandable-container
    v-for="(question, index) in questionList"
    :key="index"
    class="font-bold"
    :title="question.question"
  >
    <p class="mt-1 mb-2 font-normal">
      {{ question.answer }}
    </p>
  </tml-expandable-container>
</template>
